import { ChangeEvent } from 'react';

import {
  ChakraBox,
  ChakraFlex,
  ChakraGridItem,
  ChakraText,
  EquipUITheme,
  TextInput,
} from '@equip.health/ui';

import {
  TaskStatusValue,
  invalidNameError,
  isValidName,
  taskStatusDefinitions,
} from '~/lib/util/task.util';

import StatusLabel from '../TaskList/TaskListItem/StatusLabel';

const { h3 } = EquipUITheme.typography;

type TitleSectionProps = {
  isNonEditable: boolean;
  name: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  status: string;
};

const TitleSection = ({
  isNonEditable,
  name,
  onChange,
  status,
}: TitleSectionProps) => {
  const taskStatusValue = Number.parseInt(status, 10) - 1;
  const { color, textColor, title } =
    taskStatusDefinitions[taskStatusValue] ?? {};

  return (
    <ChakraGridItem padding="16px 0 30px">
      <ChakraFlex alignItems="center" justifyContent="space-between">
        <ChakraFlex alignItems="center" width="90%">
          {taskStatusValue === TaskStatusValue.TO_DO && (
            <ChakraBox marginRight="8px">
              <StatusLabel
                color="success.base"
                status="New"
                textColor="white"
              />
            </ChakraBox>
          )}
          {isNonEditable ? (
            <ChakraText
              {...h3}
              color="neutral.primary"
              fontWeight="400"
              paddingLeft="16px"
            >
              {name}
            </ChakraText>
          ) : (
            <TextInput
              as="h3"
              backgroundColor="transparent"
              errorMessage={invalidNameError}
              isInvalid={!isValidName(name)}
              margin={0}
              onChange={onChange}
              value={name}
            />
          )}
        </ChakraFlex>
        {(taskStatusValue === TaskStatusValue.IN_PROGRESS ||
          taskStatusValue === TaskStatusValue.DONE) && (
          <ChakraText
            background={color}
            borderRadius="8px"
            color={textColor}
            fontSize="10px"
            fontWeight="700"
            height="22px"
            marginLeft="16px"
            minWidth="max-content"
            padding="4px 8px"
          >
            {title ?? ''}
          </ChakraText>
        )}
      </ChakraFlex>
    </ChakraGridItem>
  );
};

export default TitleSection;
